import React from 'react';
import { Input, SelectPicker, InputGroup } from 'rsuite';
import styles from './GeneralRules.module.scss';
import { BorderedContentContainer } from '../../../../components';
import { useTipoRegraFilter } from '../../hooks/useTipoRegraFilter';
import { useCreateComercialTableStore } from '../../CreateComercialTable.store';
import { InputCurrency } from '../../../../../../../components';

type GeneralRulesProps = {
  onBlur: () => void;
};

type BlurName = 'percentual' | 'descontoMaximo';
type ChangeName = 'percentualIdeal' | 'descontoMaximo';

export const GeneralRules = ({ onBlur }: GeneralRulesProps) => {
  const { tipoRegraData } = useTipoRegraFilter();
  const { createComercialTableBody, setCreateComercialTableState } = useCreateComercialTableStore();

  const percentual = createComercialTableBody.regras[0].percentualIdeal;
  const descontoMaximo = createComercialTableBody.regras[0].descontoMaximo;

  const handleChangeGeneralRules = (name: ChangeName, value: number) => {
    const obj = {
      ...createComercialTableBody,
      regras: [
        {
          ...createComercialTableBody.regras[0],
          [name]: value,
        },
      ],
    };
    setCreateComercialTableState('createComercialTableBody', obj);
  };

  const handleBlurGeneralRules = (name: BlurName, value: number) => {
    const newParamValue = createComercialTableBody?.produtosBase.map((item: any) => {
      return {
        ...item,
        [name]: value,
      };
    });
    const obj = {
      ...createComercialTableBody,
      produtosBase: newParamValue,
    };
    setCreateComercialTableState('createComercialTableBody', obj);
    onBlur();
  };

  return (
    <BorderedContentContainer title="Regras gerais da tabela">
      <div className={styles.row}>
        <div className={styles['select-group']}>
          <label htmlFor="nome">Tipo de regra</label>
          <SelectPicker searchable={false} placeholder="Selecione o tipo de regra" defaultValue="PERCENTUAL_TABELA_BASE" data={tipoRegraData} />
        </div>
        <div className={styles['input-group-tax']}>
          <label htmlFor="tabela-base">Percentual ideal</label>
          <InputGroup>
            <InputCurrency
              className={styles['currency-input']}
              value={percentual}
              precision="2"
              decimalSeparator=","
              thousandSeparator="."
              onChangeEvent={(_e, _s, value) => handleChangeGeneralRules('percentualIdeal', value)}
              onBlur={() => handleBlurGeneralRules('percentual', percentual)}
            />
            <InputGroup.Addon>%</InputGroup.Addon>
          </InputGroup>
        </div>
        <div className={styles['input-group-tax']}>
          <label htmlFor="tabela-base">Desconto máximo</label>
          <InputGroup>
            <InputCurrency
              className={styles['currency-input']}
              value={descontoMaximo}
              precision="2"
              decimalSeparator=","
              thousandSeparator="."
              onChangeEvent={(_e, _s, value) => handleChangeGeneralRules('descontoMaximo', value)}
              onBlur={() => handleBlurGeneralRules('descontoMaximo', descontoMaximo)}
            />
            <InputGroup.Addon>%</InputGroup.Addon>
          </InputGroup>
        </div>
      </div>
    </BorderedContentContainer>
  );
};
